module.exports = __webpack_public_path__ + "img/B-8.072be865.png";